export * from './is-config-readonly'
